module.exports = __webpack_public_path__ + "static/media/bi.47028f4f.svg";